jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{ variant.id }}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });

  //  handle open coupon main cart
  $(document).on("click", "[handleOpenCoupon]", function () {
    $parent = $(this).parent(".t4s-type-coupon");
    $input = $parent.find("#CartDiscountcode");
    $parent.toggleClass("is-open");
    $input.slideToggle();
  });

  $(document).on('click', '[readmore_parent] [readmore_btn]',function(){
    $(this).parent('[readmore_parent]').toggleClass('readmore-click');
  });

  $(document).on('click', 'button.close-mega', function(){
    $('li.t4s-menu-item.is-action__hover').removeClass('is-action__hover');
  });

  // one click grid
  $(document).on('click', 'button.data-onclick-grid', function(){
     const is_active = $(this).parents('.t4s-feature-onclick__content').hasClass('data-overlay');
    $('.t4s-feature-onclick__content.data-overlay').removeClass('data-overlay');
    if(!is_active){
      $(this).parents('.t4s-feature-onclick__content').addClass('data-overlay');
    }else{
      $(this).parents('.t4s-feature-onclick__content').removeClass('data-overlay');
    }
  })
});